import ValueView from './ValueView';

export { ValueView };
export default ValueView;
